<!-- AddNewPersonDialog.vue -->
<template>
  <v-dialog v-model="internalAddNewPersonDialog" width="80%" max-width="1000px" scrollable >
    <v-card>
      <v-card-title>
        <span class="text-h5">Add New Person</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <!-- Basic Information Section -->
          <v-row>
            <v-col>
              <v-card color="grey lighten-5" >                
                <v-card-text>
                  <v-form ref="form" v-model="valid">
                    <v-text-field
                      v-model="newPerson.fname"
                      label="First Name"
                      :rules="[v => !!v || 'First Name is required']"
                      required
                      class="required-field"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPerson.lname"
                      label="Last Name"
                      :rules="[v => !!v || 'Last Name is required']"
                      required
                      class="required-field"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPerson.mitId"
                      label="MIT ID"
                      :rules="[v => !!v || 'MIT ID is required']"
                      required
                      class="required-field"
                    ></v-text-field>
                    <v-text-field
                      v-model="newPerson.csailId"
                      label="CSAIL ID"
                      :rules="[v => !!v || 'CSAIL ID is required']"
                      required
                      class="required-field"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Appointment Details Section -->
          <v-row>
            <v-col>
              <!-- <v-card flat style="background-color: rgb(229, 244, 229);"> -->
               <v-card color="green lighten-5" >
                <v-card-title class="text-h7">
                 Appointment
                </v-card-title>
                <v-card-text>
                  <v-select
                    v-model="newPerson.type"
                    :items="typeOptions"
                    label="Type"
                    outlined
                    dense
                    class="light-border"
                  ></v-select>
                  <v-text-field
                    v-model="newPerson.title"
                    label="Title"
                    dense
                  ></v-text-field>
                  <v-select
                    v-model="newPerson.status"
                    :items="statusOptions"
                    label="Status"
                    outlined
                    dense
                    class="light-border"
                  ></v-select>
                  <v-text-field
                    v-model="newPerson.supervisor"
                    label="Supervisor"
                    dense
                  ></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <!-- Roles Section -->
          <v-row>
            <v-col>
              <!-- <v-card flat style="background-color: rgb(221, 239, 246);"> -->
                <v-card color="blue lighten-5" >
                  <v-card-title class="text-h7">
                  Roles
                </v-card-title>
                <v-card-text>
                  <v-checkbox
                    v-for="role in roles"
                    :key="role.value"
                    v-model="newPerson.roles"
                    :label="role.name"
                    :value="role.value"
                    class="role-checkbox"
                  ></v-checkbox>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="submitNewPerson">Save</v-btn>
        <v-btn color="grey" text @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AddNewPersonDialog',
  props: {
    personDialogOpenClose: {
      type: Boolean,
      required: true,
    },
    roles: {
      type: Array,
      required: true,
    },
    typeOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      internalAddNewPersonDialog: this.personDialogOpenClose,
      newPerson: {
        fname: '',
        lname: '',
        mitId: '',
        csailId: '',
        type: '',
        title: '',
        status: '',
        supervisor: '',
        roles: [],
      },
      valid: false,
    };
  },
  watch: {
    personDialogOpenClose(val) {
      this.internalAddNewPersonDialog = val;
    },
    internalAddNewPersonDialog(val) {
      if (!val) {
        this.resetForm();
      }
      this.$emit('update:personDialogOpenClose', val);
    },
  },
  methods: {
    submitNewPerson() {
      if (this.$refs.form.validate()) {
        this.$emit('add-person', this.newPerson);
        this.internalAddNewPersonDialog = false;
      }
    },
    closeDialog() {
      this.internalAddNewPersonDialog = false;
    },
    resetForm() {
      this.newPerson = {
        fname: '',
        lname: '',
        mitId: '',
        csailId: '',
        type: '',
        title: '',
        status: '',
        supervisor: '',
        roles: [],
      };
      this.valid = false;
    },
  },
};
</script>

<style scoped>
  .required-field .v-input__label::after {
    content: ' *';
    color: red;
    font-weight: bold;
  }
  .light-border .v-input__control {
    border-color: rgba(0, 0, 0, 0.268);
    border: none !important;
    box-shadow: none;
  }
  .light-border .v-input__control:hover {
    border-color: rgba(0, 0, 0, 0.268);
    border: none !important;
  }
  .role-checkbox {
    margin-bottom: -35px;
  }
  .v-text-field__details {
    display: none;
  }
  .v-card__title {
    font-weight: normal;
  }
</style>
